import React from "react";
import { labels } from "../../../../../../../localization/labels";
import { activeFilterPageInfo } from "../../../../../../../services/FilteringUtils";
import InvolvementRoleTypeService from "../../../../../../../services/InvolvementRoleTypeService";
import PartyRoleService from "../../../../../../../services/PartyRoleService";
import PartyRoleTypeService from "../../../../../../../services/PartyRoleTypeService";
import UserService from "../../../../../../../services/UserService";
import CommonUtil from "../../../../../../../utils/CommonUtil";
import PathUtil from "../../../../../../../utils/PathUtil";
import {
  usersValidationRules as validationRules,
  validateEntity
} from "../../../../../../../validators/validationRules";
import { paths } from "../../../../../../paths";
import PageComponent from "../../../../../page/PageComponent";
import UserRoleDetail from "./UserRoleDetail";

class UserRoleDetailContainer extends PageComponent {
  constructor(props) {
    super(props);

    this.partyRoleService = new PartyRoleService();
    this.partyRoleTypeService = new PartyRoleTypeService();
    this.involvementRoleTypeService = new InvolvementRoleTypeService();
    this.userService = new UserService();

    this.sortInfo = {
      orderBy: "name",
      direction: "asc"
    };

    this.state = {
      id: this.resolveItemId(),
      partyId: PathUtil.pathParameter(this.props, "partyId")
    };
    this.state = this.initialState(this.state);
  }

  initialState = state => {
    return {
      ...state,
      disabled: true,
      entity: {
        name: undefined,
        dateFromTo: {
          dateFrom: undefined,
          dateTo: undefined
        },
        partyRoleType: undefined
      },
      involvementRoleTypes: [],
      parentInvolvementRoleTypes: [],
      partyRoleTypes: [],
      user: {
        name: undefined,
        lastName: undefined
      }
    };
  };

  componentDidUpdate(prevProps) {
    const newId = this.resolveItemId();

    if (newId !== PathUtil.pathParameter(prevProps, "id")) {
      this.state.id = newId;
      this.state.partyId = PathUtil.pathParameter(this.props, "partyId");

      this.setState(this.initialState(this.state));
      this.loadData();
    }
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    if (this.state.id) {
      this.loadSelectedEntity(this.state.id);
    }
    if (this.state.partyId) {
      this.loadUser(this.state.partyId);
    }

    this.loadRoleTypes();
  };

  loadUser = id => {
    this.prepareCall(
      this.userService.getUserByParty(
        id,
        this.onUserLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onUserLoad = data => {
    this.setState({ user: data });

    if (!this.state.id) {
      this.setComponentTitle(labels.userRole);
    }
  };

  getComponentTitle = () => {
    return this.state.entity ? this.state.entity.name : undefined;
  };

  loadSelectedEntity = id => {
    this.prepareCall(
      this.partyRoleService.getPartyRoleById(
        id,
        this.onSelectedEntityLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onSelectedEntityLoad = data => {
    this.state.partyId = data.partyId;
    this.setState({
      entity: { ...data },
      oldEntity: { ...data },
      disabled: false
    });
    this.setComponentTitle(this.state.entity.name, true);

    this.loadEntityPartyRoleType(data);
  };

  loadEntityPartyRoleType = data => {
    const url = data._links.partyRoleType.href;
    this.prepareCall(
      this.partyRoleTypeService.getEntitiesByUrl(
        url,
        this.onEntityPartyRoleTypeLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onEntityPartyRoleTypeLoad = data => {
    const { entity, oldEntity } = this.state;
    entity["partyRoleType"] = data;
    oldEntity["partyRoleType"] = data;
    this.setState({ entity, oldEntity });

    this.loadEntityPartyRoleTypeInvolvementRoleTypes(data);
    this.loadEntityParentPartyRoleTypeInvolvementRoleTypes(data);
  };

  loadEntityPartyRoleTypeInvolvementRoleTypes = data => {
    const url = data._links.involvementRoleTypes.href;
    this.prepareCall(
      this.involvementRoleTypeService.getEntitiesByUrl(
        url,
        this.onEntityPartyRoleTypeInvolvementRoleTypesLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  loadEntityParentPartyRoleTypeInvolvementRoleTypes = data => {
    const url = data._links.parentInvolvementRoleTypes.href;
    this.prepareCall(
      this.involvementRoleTypeService.getEntitiesByUrl(
        url,
        this.onParentEntityPartyRoleTypeInvolvementRoleTypesLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onEntityPartyRoleTypeInvolvementRoleTypesLoad = data => {
    if (data && data._embedded && data._embedded.content) {
      let { involvementRoleTypes } = this.state;
      involvementRoleTypes = data._embedded.content;
      this.setState({ involvementRoleTypes });
    } else {
      this.setState({ involvementRoleTypes: [] });
    }
  };

  onParentEntityPartyRoleTypeInvolvementRoleTypesLoad = data => {
    if (data && data._embedded && data._embedded.content) {
      let { parentInvolvementRoleTypes } = this.state;
      parentInvolvementRoleTypes = data._embedded.content;
      this.setState({ parentInvolvementRoleTypes });
    } else {
      this.setState({ parentInvolvementRoleTypes: [] });
    }
  };

  loadRoleTypes = () => {
    this.prepareCall(
      this.partyRoleTypeService.getEntities(
        activeFilterPageInfo,
        this.sortInfo,
        this.onRoleTypesLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onRoleTypesLoad = data => {
    if (data && data._embedded && data._embedded.content) {
      this.setState({ partyRoleTypes: data._embedded.content });
    }
  };

  onChange = event => {
    let { entity } = this.state;
    const path = event.target.id;
    CommonUtil.setDeepOnStringPath(entity, path, event.target.value);
    const disabled = !this.validator(entity);
    this.setState({ entity, disabled });
    if (event.target.id === "partyRoleType") {
      this.loadEntityPartyRoleTypeInvolvementRoleTypes(event.target.value);
    }
  };

  validator = entity => {
    return validateEntity(entity, validationRules.userRoles);
  };

  onSave = event => {
    const { entity } = this.state;
    if (!this.state.id) {
      this.createUserRole(entity);
    } else {
      this.updateUserRole(entity);
    }
  };

  updateUserRole = entity => {
    this.prepareCall(
      this.partyRoleService.patchEntity(
        entity,
        this.state.oldEntity,
        this.onDataSaveResponse,
        this.messageHandler.handleError,
        this.onSaveSuccessMessage
      )
    );
    this.performCalls();
  };

  createUserRole = entity => {
    entity["party"] = { id: this.state.partyId };
    this.prepareCall(
      this.partyRoleService.postEntity(
        entity,
        this.onDataSaveResponse,
        this.messageHandler.handleError,
        this.onSaveSuccessMessage
      )
    );
    this.performCalls();
  };

  onDataSaveResponse = data => {
    if (this.state.id) {
      this.loadSelectedEntity(this.state.id);
    } else {
      const itemPath = PathUtil.adminItemsPath(
        {
          path: paths.USERS,
          partyId: this.state.partyId
        },
        {
          path: paths.USERROLES,
          id: data.id
        }
      );
      this.changePath(itemPath, data.name);
    }
  };

  render() {
    const maxLength = {
      name: 255
    };
    if (
      !this.state.entity.partyId ||
      this.state.entity.partyId === parseInt(this.state.partyId)
    ) {
      return (
        <UserRoleDetail
          {...this.renderProps()}
          user={this.state.user}
          entity={this.state.entity}
          maxLength={maxLength}
          validationRule={validationRules.userRoles}
          partyRoleTypes={this.state.partyRoleTypes}
          onChange={this.onChange}
          onSave={this.onSave}
          disabled={this.state.disabled}
          {...this.handlerProps()}
          isNew={this.state.id ? false : true}
          involvementRoleTypes={this.state.involvementRoleTypes}
          parentInvolvementRoleTypes={this.state.parentInvolvementRoleTypes}
        />
      );
    } else {
      return null;
    }
  }
}

export default UserRoleDetailContainer;
